import React, { FC } from 'react'
import Tag from '../Tag'
import { LuggageRequirements } from '../../types'

interface Props {
  requirements: LuggageRequirements
}

const LuggageTag: FC<Props> = ({ requirements }) => {
  const { luggage_small, luggage_large } = requirements

  if (luggage_small + luggage_large === 0) {
    return null
  }

  const summary = [
    luggage_small > 0 ? `${luggage_small} sm` : null,
    luggage_large > 0 ? `${luggage_large} lg` : null,
  ].filter((s) => !!s)

  return <Tag icon="suitcase">x{summary.join(', ')}</Tag>
}

export default LuggageTag
